<template>
    <ListLayout form-title="ExternalReferrals" :has-list-scroll="true">
        <template #list-header>
            <div class="input-group search-container">
                <input
                    type="text"
                    class="form-control border-end-0"
                    placeholder="Search for Referrals by Patient Name..."
                    v-model="term"
                />
                <span class="input-group-append">
                    <div class="input-group-text bg-transparent p-2" @click="search()">
                        <i class="fas fa-search font-size-sm"></i>
                    </div>
                </span>
            </div>
        </template>
        <template #list-header-drop>
            <div class="filter mx-lg-2">
                <MultiSelectFilter
                    id="Agencies-list"
                    :on-fetch="agencySelectOptionsFetch"
                    :selected-items="selectedBranches"
                    v-on:selectedItemsUpdated="updateBranches"
                    name="Organizations/Branches"
                />
            </div>
            <div class="filter">
                <select class="form-select ps-1" name="patient-status" v-model="selectedPatientStatus">
                    <option :value="null">All Statuses</option>
                    <option v-for="item of patientStatusEnums" :value="item.value" :key="item.value">
                        <span>{{ item.label }}</span>
                    </option>
                </select>
            </div>
        </template>
        <Pagination
            ref="externalReferralListPagination"
            :pageChanged="pageChangedCallback"
            :isLoading="isLoading"
            entity="External Referral"
            :showPageSizeOptions="true"
            classes="pagination-footer"
            :pageSize="pageSize"
            v-on:updatePageSizeChanged="updatePageSizeChanged"
        >
            <StaticTableFormater
                :enabled="true"
                :isLoading="!(!isLoading && hasData)"
                :backColumnCount="1"
                :frontColumnCount="4"
                :tableColumnSettings="getCustomSettings()"
                :columnsAltered="dynamicTableToggled"
                v-model:columns="columns"
            >
                <table class="table table-responsive-md border border-gray">
                    <thead>
                        <tr class="bg-table-header table-header">
                            <th class="align-middle">
                                <SortableTh
                                    :sort-by="sortBy"
                                    v-on:sortByUpdated="sortByUpdated"
                                    :sort-order="sortOrder"
                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                    sort-string="Created"
                                    >Referral Date
                                </SortableTh>
                            </th>
                            <th>
                                <SortableTh
                                    :sort-by="sortBy"
                                    v-on:sortByUpdated="sortByUpdated"
                                    :sort-order="sortOrder"
                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                    sort-string="LastName"
                                >
                                    Patient Information
                                </SortableTh>
                            </th>
                            <th class="align-middle">
                                <SortableTh
                                    :sort-by="sortBy"
                                    v-on:sortByUpdated="sortByUpdated"
                                    :sort-order="sortOrder"
                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                    sort-string="AgencyBranch"
                                >
                                    Organizations/Branch
                                </SortableTh>
                            </th>
                            <th>
                                <SortableTh
                                    :sort-by="sortBy"
                                    v-on:sortByUpdated="sortByUpdated"
                                    :sort-order="sortOrder"
                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                    sort-string="ServiceLine"
                                >
                                    Line Of Service
                                </SortableTh>
                            </th>
                            <th class="align-middle">Referral Type</th>
                            <th class="align-middle">Date of Birth</th>
                            <th class="align-middle">
                                <SortableTh
                                    :sort-by="sortBy"
                                    v-on:sortByUpdated="sortByUpdated"
                                    :sort-order="sortOrder"
                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                    sort-string="serviceLine"
                                    class="justify-content-start"
                                >
                                    Created By
                                </SortableTh>
                            </th>
                            <th class="align-middle">Notes</th>
                            <th class="text-end align-middle">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                            <td :colspan="columns">
                                <h3>No Referrals Found.</h3>
                            </td>
                        </tr>

                        <template v-if="isLoading">
                            <tr v-for="i in loadingCount" class="table-loading" :key="`count-${i}`">
                                <td v-for="i in columns" :key="`column-${i}`">
                                    <span class="shimmer-loading"></span>
                                </td>
                            </tr>
                        </template>

                        <tr class="table-error" v-if="!isLoading && isError">
                            <td :colspan="columns">
                                <ErrorMessageHandler
                                    title="Referral list"
                                    :show-try-again="true"
                                    :try-again="search()"
                                />
                            </td>
                        </tr>
                    </tbody>
                    <template v-if="!isLoading && !isError && hasData">
                        <tbody v-for="item in page.items" :key="item.Id">
                            <CreateExternalReferralRow
                                :reset-list="pageReset"
                                :agencyServices="agencyService"
                                :patient="item"
                            />
                        </tbody>
                    </template>
                </table>
            </StaticTableFormater>
        </Pagination>
    </ListLayout>
</template>

<script src="./CentralExternalReferral.ts"></script>
